<template>
  <section class="sbc-bar" data-aos="section-animation">
    <div class="sbc-bar__inner" v-reveal>
      <div class="sbc-bar__media">
        <transition name="fade" mode="out-in">
          <NuxtImg
            format="webp"
            :key="currentImage"
            class="sbc-bar__img"
            :src="currentImage"
            alt="Salamis Bay Conti Resort Hotel"
            loading="lazy"
            placeholder
          />
        </transition>
        <svg class="sbc-bar__emblem" viewBox="190 190 460 460" aria-hidden="true">
          <g fill="#C9A26C" stroke="#C9A26C" stroke-width="4" stroke-linejoin="round"><path d="M400 211.1c-99.7 10.2-177.7 88.1-188.1 187.9-1.4 13.8-.7 39.5 1.6 53 15.6 94.1 91.4 165.2 186.4 174.9 43.5 4.5 90.1-6.2 128-29.3 49.9-30.4 85-80.5 96.5-137.6 11.7-58.2-2.1-118.8-38.1-166.8-7.9-10.4-24.7-27.7-35.7-36.6-28.6-23.1-63.6-38.5-100.4-44.1-12.5-2-38.1-2.6-50.2-1.4m52 4.4c58.3 9.8 107.9 42 140.3 91 7.8 11.8 18.7 34.3 23.1 47.7 9.9 29.9 12.8 64.6 8.1 96-8.1 54.2-39.7 105.2-84.7 137.1-53.1 37.5-121.4 47.8-183.3 27.6-75.7-24.8-130.6-92-140.5-171.9-1.3-10.9-1.3-37.1 0-48 9-72.2 55-134.8 120.5-163.9 19.6-8.7 38-13.8 59.5-16.7 13.3-1.7 43.8-1.1 57 1.1"/><path d="M318 332.4c0 18 .1 18.6 2 18.6 2 0 2-.5 1.8-18.2-.3-16.5-.5-18.3-2-18.6-1.7-.3-1.8 1.1-1.8 18.2m9.4-17c-.9 2.4.4 4.8 2.3 4.4 1.2-.2 1.8-1.2 1.8-2.8 0-2.9-3.2-4.1-4.1-1.6m33.6 6.1v7.6l-2.2-2c-4.8-4.5-12.7-3.9-17.9 1.5-3.1 3.2-3.4 4.1-3.4 9.4 0 5.5.3 6.2 3.6 9.6 4.7 4.7 10.1 5.5 15.9 2.5 3.2-1.7 4-1.8 4-.6 0 .8.9 1.5 2 1.5 2 0 2-.5 1.8-18.2-.3-16.5-.5-18.3-2-18.6-1.6-.3-1.8.6-1.8 7.3m-2.9 9.4c6.4 6.5 2 17.1-7.1 17.1-3.3 0-4.8-.6-7.1-2.9s-2.9-3.8-2.9-7.1.6-4.8 2.9-7.1 3.8-2.9 7.1-2.9 4.8.6 7.1 2.9m87.5-15.8c-9.2 2.2-15.4 10.9-14.2 20.2 1.2 10.2 8.6 16.7 19.1 16.7 7.5 0 16.9-5 15-8-.9-1.5-2-1.3-6.1 1.5-2.7 1.8-5 2.5-8.6 2.5-9.5 0-15.2-5.6-15.2-14.7 0-8.7 6.3-14.7 15.5-14.7 4.3 0 5.6.6 11.5 4.9.9.6 1.7.6 2.5-.2 1-1 .9-1.7-.5-3.2-3.9-4.3-12.4-6.5-19-5m27.1-.4c-.4.3-.7 8.7-.7 18.5 0 16.8.1 17.8 1.9 17.8 1.7 0 1.9-.9 2.3-9 .3-8.1.6-9.2 2.9-11.5 3.4-3.5 8.5-3.7 11.1-.5 1.5 1.8 1.8 4 1.8 11.6 0 8.9.1 9.4 2.1 9.4 2.1 0 2.1-.4 1.7-10.6-.4-10.5-.4-10.6-3.6-13.5-4.2-3.8-8.9-3.9-13.1-.3l-3.1 2.6v-7.6c0-5.7-.3-7.6-1.3-7.6-.8 0-1.7.3-2 .7m94.3 17.7c0 17.9.1 18.6 2 18.6 1.7 0 2-.7 2-5 0-2.8.3-5 .7-5 .3 0 3 2.2 5.9 5 3.7 3.5 6.1 5 8 5 2.6 0 2.2-.5-4.7-6.9l-7.4-6.9 4.8-4.2c2.7-2.4 5.8-5.1 7-6.1l2.2-1.8-2.8-.1c-2 0-4.5 1.4-8 4.5l-5.2 4.5-.5-9.7c-.4-8.3-.8-9.8-2.2-10.1-1.7-.3-1.8 1.1-1.8 18.2m-314 .5c0 17.4.1 18.1 2 18.1 1.8 0 2-.7 2-8.5V334h17v8.5c0 7.8.2 8.5 2 8.5 1.9 0 2-.7 2-18.1 0-16.6-.1-18-1.7-17.7-1.5.3-1.9 1.6-2.1 7.6l-.3 7.2h-16.8l-.3-7.2c-.2-6-.6-7.3-2-7.6-1.7-.3-1.8 1.1-1.8 17.7m38.3-6.9c-9 5.4-8.2 20.6 1.2 24.6 10 4.1 19.5-2 19.5-12.6 0-11-11.5-17.7-20.7-12m13.6 4.6c2.7 2.2 3.1 3.2 3.1 7.4 0 6.4-3.4 10-9.5 10-9.1 0-13.2-10.5-6.7-17.3 3.5-3.7 8.8-3.7 13.1-.1m73.2-4.9c-9.7 4.9-9.4 20.1.6 24.8 4.1 2 10.5 1.6 13.2-.9 2.2-2 3.1-2 3.1-.1 0 .8.9 1.5 2 1.5 1.9 0 2-.7 2-13s-.1-13-2-13c-1.1 0-2 .7-2 1.5 0 1.9-.9 1.9-3.1-.1-2.7-2.4-9.8-2.8-13.8-.7m12 3.3c2.5 1.4 4.9 6.2 4.9 10 0 4.8-4.7 9-10 9-3.3 0-4.8-.6-7.1-2.9-6.2-6.2-2-17.1 6.6-17.1 2 0 4.5.5 5.6 1m119.9-4.3c-3.2 1.2-7.1 5.9-8.1 9.5-3.1 11.7 8.5 21.5 19.4 16.3 4.4-2.1 7.6-6.3 5.6-7.6-.8-.5-2.5.3-4.6 2.2-3.6 3.1-8.6 3.9-12.4 1.9-1.9-1-4.9-5.9-4.9-8 0-.6 4.3-1 12-1 7.6 0 12-.4 12-1 0-2.3-2.9-7.6-5.3-9.9-2.7-2.4-10.4-3.8-13.7-2.4m10.8 4.9c1.2.8 2.7 2.4 3.2 3.5 1 1.8.7 1.9-8.5 1.9-5.9 0-9.5-.4-9.5-1s1.1-2.2 2.5-3.5c2.9-2.9 8.8-3.4 12.3-.9m20.4-3.9c-8.5 4.2-10.1 15.9-3 22.5 5.1 4.8 14.2 5 19.5.3 2.2-1.8 2.5-2.6 1.6-3.6-.9-.9-1.8-.7-3.9 1-3.9 3-10.3 2.9-14.2-.4-5.1-4.3-5.1-10.7-.1-15.4 3.1-2.9 10.6-2.9 14.3 0 2 1.6 3 1.9 3.8 1.1s.7-1.6-.2-2.7c-3.7-4.5-11.8-5.8-17.8-2.8M328 338c0 10.9.2 13 1.5 13s1.5-2.1 1.5-13-.2-13-1.5-13-1.5 2.1-1.5 13m76.3-9.8c.8 1.8 3.1 7 5.1 11.5 4 9 4.2 10.2 2.2 14.1-2.6 5.3-2.9 7.2-.9 7.2 1.4 0 3.5-4 9.3-17.2 4.1-9.4 7.7-17.6 7.9-18.1s-.7-.7-1.9-.5c-1.7.2-3 2.2-5.9 9-2 4.8-3.9 9-4.2 9.3s-2.4-3.7-4.6-8.8c-3.1-7.2-4.5-9.3-6.2-9.5-2.1-.3-2.1-.2-.8 3M245 366.5c0 1.3 20.4 1.5 177.5 1.5s177.5-.2 177.5-1.5-20.4-1.5-177.5-1.5-177.5.2-177.5 1.5m60.3 17.4c-13.8 5.1-21.5 16.1-21.5 30.6 0 8.7 2.5 15.5 7.9 21.5s11.6 9.4 20 10.9c8.8 1.6 20-.4 28-5.1l3.3-2V414h-12v10c0 10 0 10.1-2.7 11.2-1.6.6-5.9 1.2-9.8 1.2-5.7.1-7.8-.4-11.5-2.4-6.7-3.8-10.3-9.6-10.8-17.5-.4-5.5 0-7.3 2.3-12 2.1-4.4 3.7-6.2 7.8-8.6 4.8-2.8 5.8-3 13.4-2.7 7.3.3 8.6.6 12.6 3.5l4.5 3.1 3.6-3.7 3.6-3.7-2.7-2.6c-5-4.8-11.9-7.1-21.8-7.5-7.1-.3-10.1.1-14.2 1.6m70.5-.1c-10.2 3.8-18.4 12.2-20.9 21.7-1.8 6.5-.6 18.2 2.4 24.1 10.2 20 39.7 24.1 56 7.7 5-4.9 7.3-9.4 8.6-16.9 2.7-14.8-5-29.5-18.7-35.7-6.5-2.9-20.8-3.4-27.4-.9m25 12.5c2.7 1.7 5.1 4.5 6.8 7.9 2.2 4.4 2.6 6.1 2.2 11.9-.3 5.6-.9 7.6-3.4 11.1-9.6 13.7-30.2 12.5-37.6-2.1-6-11.7-1.9-24.4 9.7-30.6 2.2-1.2 5.1-1.5 10.6-1.3 6.3.2 8.2.8 11.7 3.1M435 415v32h45v-11h-33v-53h-12zm54.2-.3.3 31.8h18c20.5 0 24.6-.9 33-7.3 9.7-7.3 13.9-21.6 10.1-34.5-2.1-7.2-9.5-15.5-16.8-18.8-4.9-2.2-6.8-2.4-25.1-2.7l-19.7-.4zm39.5-18.9c7.8 4.1 12.2 13 10.8 22.1-.8 5.6-2.4 8.8-6.2 12.3-4.8 4.6-9.2 5.8-21.3 5.8h-11v-43.2l11.8.4c9.6.3 12.4.8 15.9 2.6m-217.9 78.4c-2 4.6-6.6 14.7-10.2 22.5l-6.5 14.3h3.5c3.3 0 3.7-.4 6-5.5l2.5-5.5h23.7l2.3 5.5c2.3 5.2 2.6 5.5 6 5.5h3.7l-10.2-22.5-10.1-22.5H318c-3.5 0-3.6.2-7.2 8.2m11.9 9.6 4.2 9.7-8.6.3c-4.7.2-8.7.1-8.9-.1-.5-.5 7.9-19.7 8.6-19.7.3 0 2.4 4.4 4.7 9.8m25.9 4.6 7.6 22.6h7.3l5.9-17.7 5.9-17.7 2.8 7.9c1.6 4.3 4.3 12.2 6.1 17.7l3.2 9.8h7.4l7.5-22.5 7.5-22.5h-6.7l-5.8 17.5c-3.1 9.6-6 17.5-6.3 17.5s-3.2-7.9-6.3-17.5l-5.8-17.5h-6.4l-6 17.5c-3.3 9.6-6.3 17.5-6.6 17.5s-3-7.8-6.1-17.3l-5.5-17.2-3.6-.3-3.6-.3zm73-5.2c-4.4 9.5-8.9 19.7-10.2 22.5L409 511h3.5c3.3 0 3.7-.3 6-5.5l2.4-5.5h23.9l2.2 5.5c2.1 5.1 2.5 5.5 5.6 5.5 1.9 0 3.4-.3 3.4-.8 0-.4-4.4-10.4-9.8-22.2l-9.8-21.5-3.5-.3-3.5-.3zm16.3 1.5 4 9.3h-9c-4.9 0-8.9-.3-8.9-.6 0-1.9 8.5-19.3 9.1-18.7.4.4 2.6 5 4.8 10m25.1 3.8V511h7v-13h13.9l4.1 6.1c4.5 6.5 5.5 7.2 9.5 6.7l2.6-.3-5-7.1-5.1-7.2 2.8-1.8c5.8-3.7 8.1-10.1 6.2-17-2.5-8.7-8.3-11.4-24.5-11.4H463zm24.9-15.1c5.1 2.7 6.6 9.5 3.1 13.9-2.5 3.2-7.5 4.7-15.2 4.7H470v-20h7.5c4.6 0 8.7.6 10.4 1.4m22.1 15V511h12.1c13.8 0 18.2-1 23.5-5.3 4.9-4 7.4-9.8 7.4-17 0-9.5-3.6-15.8-11.5-20-3.4-1.8-6.1-2.2-17.7-2.5l-13.8-.4zm27.6-14.3c5.9 2.8 8.4 7.1 8.4 14.5 0 11.6-6 16.4-20.5 16.4H517v-33h8.2c6.2 0 9.2.5 12.4 2.1m-177.1 58.7c-2.2 1-4.6 2.6-5.3 3.4-1.1 1.4-.9 1.9 1.5 3.6 2.7 1.9 2.9 1.9 5.8.1 3.9-2.5 10.7-2.5 12.8-.1 3.4 3.7 2.1 6-8.8 17.2-8.1 8.2-10.5 11.2-10.5 13.3v2.7h30v-7h-18.4l8.1-8.3c8.3-8.5 10.1-11.9 8.8-17.6-.3-1.5-1.9-4.1-3.6-5.7-2.6-2.4-3.9-2.9-9.7-3.2-5-.2-7.7.2-10.7 1.6m39.5 0c-7.2 3.6-11.1 14.4-9 24.6 2.1 10.1 8 15.6 16.8 15.6 10.3 0 17.2-8.5 17.2-21 0-9-3.7-16.3-10.1-19.5-3.8-2-10.6-1.9-14.9.3m12.2 6.3c4.2 2.3 6 11.9 3.8 20.1-2.1 7.3-9.8 9.2-14.4 3.7-2.3-2.7-2.6-3.9-2.6-10.9s.3-8.2 2.6-10.9c2.8-3.3 6.7-4.1 10.6-2m22.3-6.8c-1.6.8-3.8 2.3-4.7 3.4-1.7 1.9-1.7 2 .6 4.2l2.5 2.3 2.7-2.1c3.3-2.6 10.5-2.9 12.8-.5.9.8 1.6 2.9 1.6 4.7 0 2.6-1.6 4.6-10.6 13.2-8.6 8.2-10.5 10.6-10.2 12.6l.3 2.4h30l.3-3.3.3-3.2h-19.6l8.2-7.9c6.4-6.3 8.3-8.8 8.9-11.7 1-5.2-.6-10.3-3.9-12.8-3.5-2.6-14.7-3.3-19.2-1.3m39.7.8c-7 3.5-10.2 9.8-10.2 20.3 0 7.1 2.8 13.8 7.3 17 3.9 2.9 14 3.4 18.6.8 9.3-5.1 9-18.8-.4-22.8-4.4-1.8-10.3-1.8-13.9.1-1.6.9-3.1 1.3-3.3 1.1-1.3-1.2 1.2-6.9 4-9.2 2.9-2.4 3.7-2.6 9.8-2.2 6.3.5 6.8.4 7.8-1.9 1.4-3.2 1.6-2.9-2-4.2-5.1-1.8-12.9-1.3-17.7 1m13 22.6c4.2 3.8.2 11.3-6.2 11.3-3.4 0-8-3.5-8-6.1 0-6.9 8.8-10.1 14.2-5.2"/></g>
        </svg>
      </div>

      <div class="sbc-bar__content">
        <span class="sbc-bar__kicker-line" aria-hidden="true"></span>
        <!-- Kept as the actual <h1> (page's only one — see pages/index.vue
             import comments) for SEO, just styled small; the big serif
             treatment moved to the tagline below instead. -->
        <h1 class="sbc-bar__eyebrow">
          {{ language === 'en' ? '5-Star Ultra All-Inclusive Resort in Cyprus: Salamis Bay Conti' : 'Kıbrıs\'ta Ultra Her Şey Dahil Tatil Deneyimi' }}
        </h1>
        <p class="sbc-bar__title">
          {{ language === 'en' ? "The Blue of the Mediterranean, the Calm of Morning, the Rhythm of Night" : "Akdeniz'in Mavisi, Sabahın Huzuru, Gecenin Ritmi" }}
        </p>
        <p class="sbc-bar__desc">{{ generalStore().getVariable("front_1") }}</p>
        <div class="sbc-bar__actions">
          <NuxtLink :to="redirect('about')" class="sbc-bar__btn sbc-bar__btn--solid" aria-label="Learn about us">
            {{ $t("for_more") }}
            <span class="sbc-bar__btn-arrow" aria-hidden="true">&rarr;</span>
          </NuxtLink>
          <NuxtLink :to="redirect('concepts')" class="sbc-bar__btn sbc-bar__btn--outline" aria-label="See our concepts">
            {{ language === 'en' ? 'Our Concepts' : 'Konseptlerimiz' }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>
</template>


<script >
export default {
  name: "index_spa",
  data() {
    return {
      currentIndex: 0,
      imageHeight: null,
      loading: true,
      intervalId: null,
    };
  },
  computed: {
    BaseURL() {
      return import.meta.env;
    },
    images() {
      const paths = generalStore().getSectionImages;
      if (!paths || paths.length === 0) {
        // Fallback used only until the "section" carousel is populated.
        return [
          "https://api2.salamisbayconti.com/storage/carousels/January2026/piKAeKzTRX1Jx7nFYJlk.webp",
          "https://api2.salamisbayconti.com/storage/carousels/January2026/oSmltxhenrcvHumoZ5hQ.webp",
        ];
      }
      return paths.map((path) => `https://api2.salamisbayconti.com/storage/${path}`);
    },
    currentImage() {
      return this.images[this.currentIndex];
    },
    language() {
      return this.$i18n.locale;
    },
  },
  methods: {
    changeImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    redirect(route) {
      if (this.language === 'en') {
        return `/en/${route}`;
      }
      return `/${route}`;
    },
  },
  mounted() {
    this.intervalId = setInterval(this.changeImage, 6000);
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.4s cubic-bezier(0.45, 0, 0.55, 1);
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.sbc-bar {
  --sbc-navy-900: #0B1F2E;
  --sbc-gold-400: #D9B96B;
  --sbc-gold-600: #C19A45;
  background: #FBF9F6;
  padding: clamp(56px, 8vw, 128px) clamp(20px, 5vw, 88px);
}
.sbc-bar__inner {
  max-width: 1280px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: clamp(32px, 5vw, 80px);
  align-items: center;
}

.sbc-bar__media {
  position: relative;
  min-width: 0;
}
/* Transitions only on "in": the jump to "out" must be instant, otherwise an
   element that is already on screen visibly slides away and back. */
.sbc-bar__inner[data-reveal="in"] > .sbc-bar__media,
.sbc-bar__inner[data-reveal="in"] > .sbc-bar__content {
  transition: translate 1900ms cubic-bezier(.2, .7, .2, 1), opacity 1600ms ease;
}
.sbc-bar__inner[data-reveal="in"] > .sbc-bar__content { transition-delay: 350ms; }
.sbc-bar__inner[data-reveal="out"] > .sbc-bar__media { translate: -90px 0; opacity: 0; }
.sbc-bar__inner[data-reveal="out"] > .sbc-bar__content { translate: 90px 0; opacity: 0; }
.sbc-bar__img {
  display: block;
  width: 100%;
  aspect-ratio: 3 / 2;
  object-fit: cover;
}
.sbc-bar__emblem {
  position: absolute;
  right: 0;
  bottom: 0;
  width: clamp(54px, 9vw, 95px);
  height: auto;
  pointer-events: none;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, .35));
}

.sbc-bar__content {
  min-width: 0;
}
.sbc-bar__kicker-line {
  display: block;
  width: 40px;
  height: 1px;
  background: var(--sbc-gold-600);
  margin-bottom: 22px;
}
.sbc-bar__eyebrow {
  display: inline-block;
  font-family: 'Jost', sans-serif;
  font-size: .8125rem;
  font-weight: 400;
  letter-spacing: .16em;
  text-transform: uppercase;
  color: var(--sbc-navy-900);
  margin: 0 0 14px;
  text-shadow: 0 2px 6px rgba(11,31,46,.35);
}
.sbc-bar__title {
  font-family: 'Cormorant Garamond', Georgia, serif;
  font-weight: 300;
  font-size: clamp(30px, 3.8vw, 48px);
  line-height: 1.18;
  color: var(--sbc-navy-900);
  margin: 0 0 20px;
}
.sbc-bar__desc {
  max-width: 56ch;
  font-family: 'Jost', sans-serif;
  font-weight: 300;
  font-size: clamp(17px, 1.35vw, 21px);
  line-height: 1.75;
  color: rgba(11, 31, 46, .72);
  margin: 0 0 32px;
}

.sbc-bar__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  align-items: center;
}
.sbc-bar__btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 28px;
  font-family: 'Jost', sans-serif;
  font-size: .75rem;
  font-weight: 500;
  letter-spacing: .16em;
  text-transform: uppercase;
  text-decoration: none;
  transition: background 200ms ease, color 200ms ease, border-color 200ms ease;
}
.sbc-bar__btn--solid {
  background: var(--sbc-navy-900);
  color: #F4EDE1;
}
.sbc-bar__btn--solid:hover {
  background: var(--sbc-gold-600);
  color: var(--sbc-navy-900);
}
.sbc-bar__btn--outline {
  border: 1px solid #042333;
  color: #042333;
}
.sbc-bar__btn--outline:hover {
  background: #042333;
  color: #fff;
}
.sbc-bar__btn-arrow {
  font-size: .875rem;
  line-height: 1;
}

@media (max-width: 991px) {
  .sbc-bar {
    padding: 40px 20px;
  }
  .sbc-bar__content {
    text-align: center;
  }
  .sbc-bar__kicker-line {
    margin-inline: auto;
  }
  .sbc-bar__actions {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .sbc-bar__content {
    text-align: left;
  }
  .sbc-bar__kicker-line {
    margin-inline: 0;
    margin-bottom: 16px;
  }
  .sbc-bar__eyebrow {
    font-size: .625rem;
    letter-spacing: .12em;
    margin-bottom: 10px;
  }
  .sbc-bar__title {
    font-size: clamp(2.25rem, 11vw, 3.25rem);
    line-height: 1.05;
    margin-bottom: 14px;
  }
  .sbc-bar__desc {
    font-size: 1.0625rem;
    line-height: 1.55;
    margin-bottom: 24px;
  }
  .sbc-bar__actions {
    flex-wrap: nowrap;
    gap: 8px;
    justify-content: flex-start;
  }
  .sbc-bar__btn {
    flex: 1 1 0;
    justify-content: center;
    padding: 13px 12px;
    font-size: .6875rem;
    gap: 6px;
    letter-spacing: .12em;
  }
}
/* Mobile: +10px vertical padding */
@media (max-width: 767px) {
  .sbc-bar { padding-block: 50px; }
}
</style>
